import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import "./CardHover.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollProgress from "./components/ScrollProgress";
import BackToTop from "./components/BackToTop";
import ResetToHomeOnReload from "./components/ResetToHomeOnReload";

// Each page is loaded only when its route is visited (code-splitting).
// This shrinks the initial JS bundle, which speeds first load + LCP.
const Home = lazy(() => import("./pages/Home"));
const Services = lazy(() => import("./pages/Services"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const WhyChooseUs = lazy(() => import("./pages/WhyChooseUs"));
const Quote = lazy(() => import("./pages/Quote"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  return (
    <div className="App">
      <ResetToHomeOnReload />
      <ScrollProgress />
      <ScrollToTop />

      <Navbar />

      <main className="page-wrapper">
        <Suspense fallback={<div style={{ minHeight: "70vh" }} />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/why-choose-us" element={<WhyChooseUs />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;